import { CloseFill18Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex, Text } from "shared/components/Spor";

type SearchResultTextProps = {
  searchHits: number;
  cancelSearch: () => void;
};

export const SearchResultText: FC<SearchResultTextProps> = ({
  searchHits,
  cancelSearch,
}) => {
  const { t } = useTranslation();
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Text variant="sm" color="text.highlight">
        {searchHits} treff
      </Text>
      <Button
        size="xs"
        variant="ghost"
        fontWeight="400"
        rightIcon={<CloseFill18Icon m="auto" />}
        onClick={cancelSearch}
      >
        {t("Nullstill søk")}
      </Button>
    </Flex>
  );
};
